import VanillaSwipe from "vanilla-swipe";
import justDebounce from "just-debounce";

const minDelta = 10;
const isEventCancelable = (evt) => evt?.cancelable === true;


const parents = function (node) {
  var nodes = [node]
  for (; node; node = node.parentNode) {
    nodes.unshift(node)
  }
  return nodes
}
const isParentElementGridDisplay = function (el) {
  return window.getComputedStyle(el).display === 'grid'
}

const findAncestorWithOutOfFlowPosition = function (el) {
  const parent = el.parentNode;
  if (parent === document.body) {
    return document.body
  }
  if (window.getComputedStyle(parent).position === 'static') {
    return findAncestorWithOutOfFlowPosition(parent)
  } else {
    return parent
  }
}

const commonAncestor = function () {
  const parentEls = new Array(...arguments).map((el) => parents(el))
  if (parentEls.length === 1) {
    return parentEls[0][parentEls[0].length - 3]
  }
  let commonAncestor = parentEls[0][0];
  if (parentEls.some((parent) => parent[0] !== commonAncestor)) {
    throw "No common ancestor!"
  }
  for (var i = 0; i < parentEls[0].length; i++) {
    const currElement = parentEls[0][i];
    if (parentEls.some(elParents => elParents[i] !== currElement)) {
      return commonAncestor
    } else {
      commonAncestor = currElement
    }
  }
  return parentEls[0][parentEls[0].length - 3]
}

const getExtractedStyles = function (allEls) {
  let positionBoundingAncestorArr = allEls.map(el => {
    return findAncestorWithOutOfFlowPosition(el)
  })
  positionBoundingAncestorArr = positionBoundingAncestorArr.map((el) => el.getBoundingClientRect())
  let elsBoundingRect = allEls.map(el => el.getBoundingClientRect())
  let parentElsBoundingRect = allEls.map(el => el.parentNode.getBoundingClientRect())
  let elsStyles = allEls.map(el => window.getComputedStyle(el))
  let parentElsStyles = allEls.map(el => window.getComputedStyle(el.parentNode))

  const parentElementDisplayArr = parentElsStyles.map(elStyle => elStyle.getPropertyValue("display"))
  return allEls.map((el, index) => {
    const elStyle = elsStyles[index]
    const elRect = elsBoundingRect[index]
    const boundingAncestorRect = positionBoundingAncestorArr[index]
    const parentElRect = parentElsBoundingRect[index]
    return {
      position: elStyle.getPropertyValue("position"),
      zIndex: elStyle.getPropertyValue('z-index'),
      left: elStyle.getPropertyValue('left'),
      top: elStyle.getPropertyValue('top'),
      isParentElementGridDisplay: parentElementDisplayArr[index] === 'grid',
      doesParentElementGridDisplayHaveTemplateAreas: parentElsStyles[index].getPropertyValue('grid-template-areas') !== 'none',
      clientWidth: el.clientWidth,
      xDiff: elRect.x - parentElRect.x,
      yDiff: elRect.y,
      boundingAncestorBaseXOffset: elRect.x - boundingAncestorRect.x,
      boundingAncestorBaseYOffset: elRect.y - boundingAncestorRect.y,
      elBoundingRectWidth: elRect.width,
      elBoundingRectHeight: elRect.height,
      elBoundingRectLeft: elRect.left,
      elBoundingRectTop: elRect.top,
      originalStyle: el.style.cssText,
    }
  })
}

export const initMobileSwipe = ({el, cb, shouldStartSwipeFunc, swipeEndCb, swipeStartCb, additionalEls = [], elementsToPreserveStyleOf = [], isRtl}) => {
  if (!VanillaSwipe.isTouchEventsSupported()) {
    return;
  }
  const allEls = [el, ...additionalEls]

  const commonAncestorEl = commonAncestor(...allEls)
  let originalStyleText = allEls.map(el => el.style.cssText)
  const elExtractedStyles = getExtractedStyles(allEls)
  const elementsToPreserveStyleOfStyles = elementsToPreserveStyleOf.map(el => el.style.cssText)
  const context = {
    isRtl,
    allEls,
    isFinishingSwiping: false,
    swipeEndCb,
    elObjs: [],
    didFinishSwipe: false,
    didFetch: false,
    commonAncestorEl,
    shouldStartSwipeFunc,
    cb,
    initElCopy: async function (e, {deltaY, deltaX, directionX}) {
      const targetEl = e.target
      this.didFinishSwipe = false
      if (this.isFinishingSwiping || Math.abs(deltaY) >= minDelta || !isEventCancelable(e) || !this.shouldStartSwipeFunc?.(...arguments)) {
        this.didFinishSwipe = true
        return;
      }

      this.isSafari = Math.abs(deltaX) === Math.floor(Math.abs(deltaX))
      swipeStartCb && swipeStartCb()
      this.swipeStartPromise = new Promise(async (resolve) => {
        this.swipeStartPromiseResolve = resolve
      })

      this.elExtractedStyles = getExtractedStyles(allEls)
      const commonAncestorEl = commonAncestor(...allEls)
      this.commonAncestorEl = commonAncestorEl
      this.elementsToPreserveStyleOfStyles = elementsToPreserveStyleOfStyles
      this.elementsToPreserveStyleOf = elementsToPreserveStyleOf
      const elCopys = allEls.map(el => el.cloneNode(true))
      commonAncestorEl.style.setProperty('display', 'none', 'important')
      const parentEls = allEls.map(el => el.parentNode)
      elCopys.forEach((elCopy, index) => {
        elCopy.classList.add('copy-node')
        parentEls[index].insertBefore(elCopy, allEls[index]);
      })
      let direction = directionX
      if(direction === 'NONE') {
        direction = deltaX > 0 ? 'RIGHT' : 'LEFT'
      }
      this.cb(getSwipeDirection(direction, this.isRtl), this.isSafari);
      this.elObjs = allEls.map((el, index) => {
        const elCopy = elCopys[index]
        const elExtractedStyle = elExtractedStyles[index]
        const position = elExtractedStyle.position
        const isPositionAbsoluty = ['sticky', 'fixed', 'absolute'].indexOf(position) !== -1
        const zIndex = parseInt(elExtractedStyle.zIndex) || index
        let baseYOffset = 0
        let baseXoffset = 0
        if (elExtractedStyle.isParentElementGridDisplay) {
          baseXoffset = elExtractedStyle.doesParentElementGridDisplayHaveTemplateAreas ? 0 : elExtractedStyle.xDiff
          baseYOffset = elExtractedStyle.doesParentElementGridDisplayHaveTemplateAreas ? 0 : elExtractedStyle.yDiff
        } else if (isPositionAbsoluty) {
          baseYOffset = parseInt(elExtractedStyle.left) || 0
          baseXoffset = parseInt(elExtractedStyle.top) || 0
        } else {
          baseXoffset = elExtractedStyle.boundingAncestorBaseXOffset
          baseYOffset = elExtractedStyle.boundingAncestorBaseYOffset
        }
        const originalStyle = elExtractedStyle.originalStyle
        const baseStyle = `
          top: ${baseYOffset}px;
          left: ${baseXoffset}px;
          max-width: ${elExtractedStyle.elBoundingRectWidth}px;
          max-height: ${elExtractedStyle.elBoundingRectHeight}px;
          min-width: ${elExtractedStyle.elBoundingRectWidth}px;
          min-height: ${elExtractedStyle.elBoundingRectHeight}px;
        `

        let elPositionText = baseStyle;
        let elCopyPositionText = baseStyle;
        if (isPositionAbsoluty) {
          elPositionText += `
            z-index: ${zIndex} !important;
            position: ${position};
          `
          elCopyPositionText += `
            z-index: ${zIndex + 1} !important;
            position: ${position};
          `
        } else {
          elPositionText += `
            position: absolute;
            z-index: ${zIndex} !important;
            max-height: ${elExtractedStyle.elBoundingRectHeight}px;
          `
          elCopyPositionText += `
            position: relative;
            top: 0 !important;
            left: 0 !important;
            z-index: ${zIndex + 1} !important;
          `
        }

        const elStyle = `
          transition: transform 0s ease-out;
          will-change: transform;
          transform: translate3d(${-1 * Math.sign(deltaX) * elExtractedStyle.clientWidth}px, 0, 0);
          ${elPositionText}
        `;
        const elCopyStyle = `
          will-change: transform;
          transition: transform 0.3s ease-out;
          transform: translate3d(0px, 0, 0);
          ${elCopyPositionText}
        `;
        el.style = elStyle

        elCopy.style = elCopyStyle


        return {
          newZIndex: zIndex,
          elStyle,
          elCopyStyle,
          el,
          elCopy,
          elPositionText,
          baseXoffset,
          elCopyPositionText,
          originalStyle,
          elExtractedStyle,
        }
      })

      commonAncestorEl.style.setProperty('display', '')
      await new Promise((resolve) => window.requestAnimationFrame(() => {
        resolve()
      }))
      this.elObjs.forEach((elObj, index) => {
        const {el, elCopy, elExtractedStyle} = elObj
        el.style.setProperty('transform', `translate3d(${-1 * Math.sign(deltaX) * elExtractedStyle.clientWidth + deltaX}px, 0, 0)`)
        el.style.setProperty('transition-duration', `0.3s`)
        elCopy.style.setProperty('transform', `translate3d(${deltaX}px, 0, 0)`)
      })

      this.didFetch = !this.didFetch;
      this.swipeStartPromiseResolve()
      this.swipeStartPromise = null

      const intervalIdx = setInterval(() => {
        if(!document.body.contains(targetEl)) {
          swipeEndHandler.call(this, e, {directionX,deltaX})
          clearInterval(intervalIdx)
        }
      }, 350)
      this.intervalIdx = intervalIdx
    }
  }

  const VS = new VanillaSwipe({
    element: commonAncestorEl,
    onSwipeStart: context.initElCopy.bind(context),
    onSwiping: justDebounce(handler.bind(context), 50, true, true),
    onSwiped: swipeEndHandler.bind(context),
    mouseTrackingEnabled: true,
    delta: minDelta,
    directionDelta: 1,
    preventDefaultTouchmoveEvent: false,
  });
  VS.init();
  context.VS = VS;
  return VS
}

const handler = async function (e, {deltaX, directionX, directionY, deltaY}) {
  if(!this.shouldStartSwipeFunc?.(...arguments)) {
    this.didFinishSwipe = true
    return;
  }
  if(this.didFinishSwipe) {
    return;
  }

  const originalDeltaX = this.deltaX;
  const eventCancelable = isEventCancelable(e);
  if (eventCancelable) {
    e.stopPropagation()
    e.preventDefault()
  }
  const didChangeDirection = !!this.deltaX && Math.sign(originalDeltaX) !== Math.sign(deltaX)
  this.deltaX = deltaX
  if (this.swipeStartPromise) {
    await this.swipeStartPromise
  }

  setElDelta.call(this, didChangeDirection);
  this.shouldFetch = this.shouldStartSwipeFunc?.(...arguments) && (this.shouldFetch || didChangeDirection)
  if (this.shouldFetch) {
    this.shouldFetch = false
    this.didFetch = !this.didFetch;

    let direction = directionX
    if(direction === 'NONE') {
      direction = deltaX > 0 ? 'RIGHT' : 'LEFT'
    }
    this.cb(getSwipeDirection(direction, this.isRtl));
  }
}

const swipeEndHandler = async function (e, {directionX,deltaX}) {
  await this.swipeStartPromise
  if(this.didFinishSwipe) {
    return;
  }
  clearInterval(this.intervalIdx)
  this.isFinishingSwiping = true
  this.shouldFetch = !this.didFinishSwipe && this.shouldStartSwipeFunc?.(...arguments) && (this.shouldFetch || Math.sign(deltaX) !== Math.sign(this.deltaX))
  if (this.shouldFetch) {
    this.shouldFetch = false  
    this.didFetch = !this.didFetch;
    let direction = directionX
    if(direction === 'NONE') {
      direction = deltaX > 0 ? 'RIGHT' : 'LEFT'
    }
    this.cb(getSwipeDirection(direction, this.isRtl));
  }
  const didFetch = this.didFetch
  this.didFetch = false

  this.elObjs.forEach((elObj, index) => {
    const {el, elCopy, newZIndex, elExtractedStyle} = elObj
    el.style.setProperty('transition-duration', '0.15s')
    el.style.setProperty('transform', `translate3d(${didFetch ? 0 : Math.sign(-this.deltaX) * elObj.elExtractedStyle.clientWidth}px, 0, 0)`)
    el.style.setProperty('z-index', `${elObj.newZIndex + 2}`)
    elCopy.style.setProperty('transform', `translate3d(${didFetch ? Math.sign(this.deltaX) * elObj.elExtractedStyle.clientWidth : 0}px, 0, 0)`)
    elCopy.style.setProperty('z-index', `${elObj.newZIndex + 1}`)
  })

  await new Promise(resolve => setTimeout(resolve, 100))

  this.elObjs.forEach((elObj, index) => {
    const el = elObj.el;
    el.style.cssText = elObj.originalStyle
  })

  let copyElementsInDom = [...document.querySelectorAll('.copy-node')]
  while(copyElementsInDom.length) {
    copyElementsInDom.forEach(el => el.remove())
    copyElementsInDom = [...document.querySelectorAll('.copy-node')]
  }

  this.commonAncestorEl.style.cssText = '';
  this.deltaX = 0
  this.didFetch = false
  this.elementsToPreserveStyleOf.forEach((el, index) => {
    el.style.cssText = this.elementsToPreserveStyleOfStyles[index];
  })
  this.elementsToPreserveStyleOf.forEach((el, index) => {
    while(el.style.cssText !== this.elementsToPreserveStyleOfStyles[index]) {
      el.style.cssText = this.elementsToPreserveStyleOfStyles[index];
    }
  })
  this.swipeEndCb()
  await new Promise(res => setTimeout(res))
  this.isFinishingSwiping = false

}

const getSwipeDirection = function (direction, reverse = false) {
  if (direction === 'RIGHT') {
    return reverse ? 'next' : 'prev'
  } else {
    return reverse ? 'prev' : 'next'
  }
}

const setElDelta = async function (didChangeDirection = false) {
  window.cancelAnimationFrame(this.requestAnimationFrameId)
  const swipeDeltaInPx = this.deltaX
  this.didChangeDirection = this.didChangeDirection || didChangeDirection
  const swipeDuration = this.didChangeDirection ? '0s' : '0.3s';

  this.requestAnimationFrameId = window.requestAnimationFrame(async () => {
    if(this.isFinishingSwiping) {
      return;
    }
    this.requestAnimationFrameId = null
    this.elObjs.forEach((elObj, index) => {
      const {el, elCopy, elExtractedStyle} = elObj
      const complementaryDelta = -1 * Math.sign(swipeDeltaInPx) * elObj.elExtractedStyle.clientWidth + swipeDeltaInPx;
      const newZIndex = elObj.newZIndex;
      el.style.setProperty('transition-duration', swipeDuration)
      el.style.setProperty('transform', `translate3d(${complementaryDelta}px, 0, 0)`)
      el.style.setProperty('z-index', `${newZIndex}`)
      elCopy.style.setProperty('transform', `translate3d(${swipeDeltaInPx}px, 0, 0)`)
      elCopy.style.setProperty('z-index', `${newZIndex + 1}`)
    })
    this.didChangeDirection = false

  })
}

export default {
  initMobileSwipe,

}
